import React, { ReactElement } from 'react';

export type IconType = 'right_arrow'
| 'left_arrow'
| 'up_arrow'
| 'down_arrow'
| 'double_left_arrow'
| 'double_right_arrow'
| 'calendar'
| 'send'
| 'message'
| 'edit'
| 'add'
| 'remove'
| 'trash'
| 'checkmark'
| 'visible'
| 'download'
| 'time'
| 'list'
| 'search'
| 'close'
| 'info'
| 'warning'
| 'filter'
| 'upload'
| 'user'
| 'folder'
| 'play'
| 'file'
| 'help'
| 'word'
| 'pdf'
| 'lan'
| 'line_axis'
| 'table_rows'
| 'stack'
| 'toggle'
| 'home'
| 'archives'
| 'sprout'
| 'meteorology'
| 'flux'
| 'wind'
| 'admin'
| 'video'
| 'locked'
| 'no_filter'
| 'open_in_new'
| 'paper_plane'
| 'chip'
| 'layers'
| 'refresh'
| 'bell'
| 'more_horiz'
| 'crop_square'
| 'grid_view'
| 'grid_view_outline'
| 'star'
| 'sort_ascending'
| 'sort_descending';

export const svgs: {
  [key in 'right_arrow'
  | 'left_arrow'
  | 'up_arrow'
  | 'down_arrow'
  | 'double_left_arrow'
  | 'double_right_arrow'
  | 'calendar'
  | 'send'
  | 'message'
  | 'edit'
  | 'add'
  | 'remove'
  | 'trash'
  | 'checkmark'
  | 'visible'
  | 'download'
  | 'time'
  | 'list'
  | 'search'
  | 'close'
  | 'info'
  | 'warning'
  | 'filter'
  | 'upload'
  | 'user'
  | 'folder'
  | 'play'
  | 'file'
  | 'help'
  | 'word'
  | 'pdf'
  | 'lan'
  | 'line_axis'
  | 'table_rows'
  | 'stack'
  | 'toggle'
  | 'home'
  | 'archives'
  | 'sprout'
  | 'meteorology'
  | 'flux'
  | 'wind'
  | 'admin'
  | 'video'
  | 'locked'
  | 'no_filter'
  | 'open_in_new'
  | 'paper_plane'
  | 'chip'
  | 'layers'
  | 'refresh'
  | 'bell'
  | 'more_horiz'
  | 'crop_square'
  | 'grid_view'
  | 'grid_view_outline'
  | 'star'
  | 'sort_ascending'
  | 'sort_descending'
  ]: ReactElement<any>; } = {
  right_arrow: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M10.02 6L8.61 7.41 13.19 12l-4.58 4.59L10.02 18l6-6-6-6z" />
    </>
  ),
  left_arrow: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12l4.58-4.59z" />
    </>
  ),
  up_arrow: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14l-6-6z" />
    </>
  ),
  down_arrow: (
    <>
      <path d="M24 24H0V0h24v24z" fill="none" opacity=".87" />
      <path d="M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6-1.41-1.41z" />
    </>
  ),
  double_left_arrow: (
    <>
      <g><rect fill="none" height="24" width="24" /></g>
      <g>
        <g>
          <polygon points="17.59,18 19,16.59 14.42,12 19,7.41 17.59,6 11.59,12" />
          <polygon points="11,18 12.41,16.59 7.83,12 12.41,7.41 11,6 5,12" />
        </g>
      </g>
    </>
  ),
  double_right_arrow: (
    <>
      <g><rect fill="none" height="24" width="24" /></g>
      <g>
        <g>
          <polygon points="6.41,6 5,7.41 9.58,12 5,16.59 6.41,18 12.41,12" />
          <polygon points="13,6 11.59,7.41 16.17,12 11.59,16.59 13,18 19,12" />
        </g>
      </g>
    </>
  ),
  calendar: (
    <>
      <g><rect fill="none" height="24" width="24" /></g>
      <g><path d="M19,4h-1V2h-2v2H8V2H6v2H5C3.89,4,3.01,4.9,3.01,6L3,20c0,1.1,0.89,2,2,2h14c1.1,0,2-0.9,2-2V6C21,4.9,20.1,4,19,4z M19,20 H5V10h14V20z M19,8H5V6h14V8z M9,14H7v-2h2V14z M13,14h-2v-2h2V14z M17,14h-2v-2h2V14z M9,18H7v-2h2V18z M13,18h-2v-2h2V18z M17,18 h-2v-2h2V18z" /></g>
    </>
  ),
  send: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M4.01 6.03l7.51 3.22-7.52-1 .01-2.22m7.5 8.72L4 17.97v-2.22l7.51-1M2.01 3L2 10l15 2-15 2 .01 7L23 12 2.01 3z" />
    </>
  ),
  message: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z" />
    </>
  ),
  edit: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M14.06 9.02l.92.92L5.92 19H5v-.92l9.06-9.06M17.66 3c-.25 0-.51.1-.7.29l-1.83 1.83 3.75 3.75 1.83-1.83c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.2-.2-.45-.29-.71-.29zm-3.6 3.19L3 17.25V21h3.75L17.81 9.94l-3.75-3.75z" />
    </>
  ),
  add: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z" />
    </>
  ),
  remove: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 13H5v-2h14v2z" />
    </>
  ),
  trash: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M14.12 10.47L12 12.59l-2.13-2.12-1.41 1.41L10.59 14l-2.12 2.12 1.41 1.41L12 15.41l2.12 2.12 1.41-1.41L13.41 14l2.12-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4zM6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM8 9h8v10H8V9z" />
    </>
  ),
  checkmark: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z" />
    </>
  ),
  visible: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M12 6c3.79 0 7.17 2.13 8.82 5.5C19.17 14.87 15.79 17 12 17s-7.17-2.13-8.82-5.5C4.83 8.13 8.21 6 12 6m0-2C7 4 2.73 7.11 1 11.5 2.73 15.89 7 19 12 19s9.27-3.11 11-7.5C21.27 7.11 17 4 12 4zm0 5c1.38 0 2.5 1.12 2.5 2.5S13.38 14 12 14s-2.5-1.12-2.5-2.5S10.62 9 12 9m0-2c-2.48 0-4.5 2.02-4.5 4.5S9.52 16 12 16s4.5-2.02 4.5-4.5S14.48 7 12 7z" />
    </>
  ),
  download: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 9h-4V3H9v6H5l7 7 7-7zm-8 2V5h2v6h1.17L12 13.17 9.83 11H11zm-6 7h14v2H5z" />
    </>
  ),
  time: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
    </>
  ),
  list: (
    <>
      <rect fill="none" height="24" width="24" />
      <path d="M3,5v14h18V5H3z M7,7v2H5V7H7z M5,13v-2h2v2H5z M5,15h2v2H5V15z M19,17H9v-2h10V17z M19,13H9v-2h10V13z M19,9H9V7h10V9z" />
    </>
  ),
  search: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
    </>
  ),
  close: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z" />
    </>
  ),
  info: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z" />
    </>
  ),
  warning: (
    <path d="M11 15h2v2h-2v-2zm0-8h2v6h-2V7zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
  ),
  filter: (
    <g>
      <path d="M0,0h24 M24,24H0" fill="none" />
      <path d="M7,6h10l-5.01,6.3L7,6z M4.25,5.61C6.27,8.2,10,13,10,13v6c0,0.55,0.45,1,1,1h2c0.55,0,1-0.45,1-1v-6 c0,0,3.72-4.8,5.74-7.39C20.25,4.95,19.78,4,18.95,4H5.04C4.21,4,3.74,4.95,4.25,5.61z" />
      <path d="M0,0h24v24H0V0z" fill="none" />
    </g>
  ),
  upload: (
    <>
      <g><rect fill="none" height="24" width="24" /></g>
      <g><path d="M18,15v3H6v-3H4v3c0,1.1,0.9,2,2,2h12c1.1,0,2-0.9,2-2v-3H18z M7,9l1.41,1.41L11,7.83V16h2V7.83l2.59,2.58L17,9l-5-5L7,9z" /></g>
    </>
  ),
  user: (
    <g>
      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM7.35 18.5C8.66 17.56 10.26 17 12 17s3.34.56 4.65 1.5c-1.31.94-2.91 1.5-4.65 1.5s-3.34-.56-4.65-1.5zm10.79-1.38C16.45 15.8 14.32 15 12 15s-4.45.8-6.14 2.12C4.7 15.73 4 13.95 4 12c0-4.42 3.58-8 8-8s8 3.58 8 8c0 1.95-.7 3.73-1.86 5.12z" />
      <path d="M12 6c-1.93 0-3.5 1.57-3.5 3.5S10.07 13 12 13s3.5-1.57 3.5-3.5S13.93 6 12 6zm0 5c-.83 0-1.5-.67-1.5-1.5S11.17 8 12 8s1.5.67 1.5 1.5S12.83 11 12 11z" />
    </g>
  ),
  folder: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M9.17 6l2 2H20v10H4V6h5.17M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z" />
    </>
  ),
  play: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M10 8.64L15.27 12 10 15.36V8.64M8 5v14l11-7L8 5z" />
    </>
  ),
  file: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zM6 20V4h7v5h5v11H6z" />
    </>
  ),
  help: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
    </>
  ),
  word: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path fillRule="evenodd" d="M9 7V2.221a2 2 0 0 0-.5.365L4.586 6.5a2 2 0 0 0-.365.5H9Zm2 0V2h7a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9h5a2 2 0 0 0 2-2Zm-1.02 4.804a1 1 0 1 0-1.96.392l1 5a1 1 0 0 0 1.838.319L12 15.61l1.143 1.905a1 1 0 0 0 1.838-.319l1-5a1 1 0 0 0-1.962-.392l-.492 2.463-.67-1.115a1 1 0 0 0-1.714 0l-.67 1.116-.492-2.464Z" clipRule="evenodd" />
    </>
  ),
  pdf: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path fillRule="evenodd" d="M9 2.221V7H4.221a2 2 0 0 1 .365-.5L8.5 2.586A2 2 0 0 1 9 2.22ZM11 2v5a2 2 0 0 1-2 2H4a2 2 0 0 0-2 2v7a2 2 0 0 0 2 2 2 2 0 0 0 2 2h12a2 2 0 0 0 2-2 2 2 0 0 0 2-2v-7a2 2 0 0 0-2-2V4a2 2 0 0 0-2-2h-7Zm-6 9a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h.5a2.5 2.5 0 0 0 0-5H5Zm1.5 3H6v-1h.5a.5.5 0 0 1 0 1Zm4.5-3a1 1 0 0 0-1 1v5a1 1 0 0 0 1 1h1.376A2.626 2.626 0 0 0 15 15.375v-1.75A2.626 2.626 0 0 0 12.375 11H11Zm1 5v-3h.375a.626.626 0 0 1 .625.626v1.748a.625.625 0 0 1-.626.626H12Zm5-5a1 1 0 0 0-1 1v5a1 1 0 1 0 2 0v-1h1a1 1 0 1 0 0-2h-1v-1h1a1 1 0 1 0 0-2h-2Z" clipRule="evenodd" />
    </>
  ),
  lan: (
    <>
      <g><rect fill="none" height="24" width="24" /></g>
      <g><path d="M13,22h8v-7h-3v-4h-5V9h3V2H8v7h3v2H6v4H3v7h8v-7H8v-2h8v2h-3V22z M10,7V4h4v3H10z M9,17v3H5v-3H9z M19,17v3h-4v-3H19z" /></g>
    </>
  ),
  line_axis: (
    <path d="M22 7.93L20.59 6.52L16.56 11.05L9.5 4.5L2 12.01L3.5 13.51L9.64 7.36L15.23 12.54L13.5 14.49L9.5 10.49L2 18L3.5 19.5L9.5 13.49L13.5 17.49L16.69 13.9L20.59 17.51L22 16.1L18.02 12.4L22 7.93Z" />
  ),
  table_rows: (
    <path d="M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM19 5V8H5V5H19ZM19 10V14H5V10H19ZM5 19V16H19V19H5Z" />
  ),
  stack: (
    <path transform="scale(1.2)" d="M0 10V12H20V10H0ZM0 5V7H20V5H0ZM0 0V2H20V0H0Z" />
  ),
  crop_square: (
    <path fillRule="evenodd" d="M4 4H20V20H4V4ZM6 6V18H18V6H6Z" />
  ),
  grid_view: (
    <>
      <rect x="3" y="3" width="8" height="8" rx="1.5" />
      <rect x="13" y="3" width="8" height="8" rx="1.5" />
      <rect x="3" y="13" width="8" height="8" rx="1.5" />
      <rect x="13" y="13" width="8" height="8" rx="1.5" />
    </>
  ),
  grid_view_outline: (
    <g fill="none" stroke="var(--ee-text-secondary)" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="3" width="7" height="7" rx="1.5" />
      <rect x="14" y="3" width="7" height="7" rx="1.5" />
      <rect x="3" y="14" width="7" height="7" rx="1.5" />
      <rect x="14" y="14" width="7" height="7" rx="1.5" />
    </g>
  ),
  toggle: (
    <path transform="scale(1.2)" d="M0 10V12H20V10H0ZM0 5V7H20V5H0ZM0 0V2H20V0H0Z" />
  ),
  home: (
    <path transform="scale(1.2)" d="M9.99935 5.15829L14.166 8.90829V15.4166H12.4993V10.4166H7.49935V15.4166H5.83268V8.90829L9.99935 5.15829ZM9.99935 2.91663L1.66602 10.4166H4.16602V17.0833H9.16602V12.0833H10.8327V17.0833H15.8327V10.4166H18.3327L9.99935 2.91663Z" />
  ),
  archives: (
    <g transform="scale(1.2, 1.2)">
      <path d="M2.4987 16.2499H16.6654V17.9166H2.4987C1.58203 17.9166 0.832031 17.1666 0.832031 16.2499V5.41658H2.4987V16.2499ZM19.1654 5.41658V12.9166C19.1654 13.8333 18.4154 14.5833 17.4987 14.5833H5.83203C4.91536 14.5833 4.16536 13.8333 4.16536 12.9166L4.1737 3.74992C4.1737 2.83325 4.91536 2.08325 5.83203 2.08325H9.9987L11.6654 3.74992H17.4987C18.4154 3.74992 19.1654 4.49992 19.1654 5.41658ZM5.83203 12.9166H17.4987V5.41658H10.9737L9.30703 3.74992H5.83203V12.9166Z" />
    </g>
  ),
  sprout: (
    <g fill="none" stroke="var(--ee-text-strong)" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 20 c-1-5-3-8-7-9 c1 6 4 8 7 9z" />
      <path d="M12 20 c1-5 3-9 8-10 c-1 6-4 9-8 10z" />
      <path d="M12 20 v6" />
    </g>
  ),
  meteorology: (
    <g transform="scale(1.26, 1.33)">
      <path d="M12.0938 11.775C11.6687 9.61875 9.775 8 7.5 8C5.69375 8 4.13125 9.025 3.35 10.525C1.46875 10.725 0 12.3125 0 14.25C0 16.3187 1.68125 18 3.75 18H11.875C13.6 18 15 16.6 15 14.875C15 13.225 13.7188 11.8875 12.0938 11.775ZM11.875 16.75H3.75C2.36875 16.75 1.25 15.6312 1.25 14.25C1.25 12.8687 2.36875 11.75 3.75 11.75C5.13125 11.75 6.25 12.8687 6.25 14.25H7.5C7.5 12.525 6.3375 11.075 4.75 10.6375C5.38125 9.8 6.375 9.25 7.5 9.25C9.39375 9.25 10.9375 10.7937 10.9375 12.6875V13H11.875C12.9062 13 13.75 13.8437 13.75 14.875C13.75 15.9062 12.9062 16.75 11.875 16.75Z" />
      <path d="M8.66545 2.65224L7.52 1.5456L6.62273 2.41731L7.76182 3.52396L8.66545 2.65224ZM5 6.15147H6.90909V7.38794H5V6.15147ZM11.3636 0H12.6364V1.8238H11.3636V0ZM16.48 1.5425L17.376 2.41236L16.2369 3.51901L15.3415 2.64853L16.48 1.5425ZM15.3345 10.8872L16.4736 12L17.3709 11.1283L16.2255 10.0216L15.3345 10.8872ZM17.0909 6.15147H19V7.38794H17.0909V6.15147ZM12 3.06028C9.89364 3.06028 8.18182 4.72334 8.18182 6.76971C8.18182 8.81607 9.89364 10.4791 12 10.4791C14.1064 10.4791 15.8182 8.81607 15.8182 6.76971C15.8182 4.72334 14.1064 3.06028 12 3.06028ZM12 9.24266C10.5936 9.24266 9.45455 8.13601 9.45455 6.76971C9.45455 5.4034 10.5936 4.29675 12 4.29675C13.4064 4.29675 14.5455 5.4034 14.5455 6.76971C14.5455 8.13601 13.4064 9.24266 12 9.24266Z" />
    </g>
  ),
  flux: (
    <g transform="scale(1.2, 1.5)">
      <path fillRule="evenodd" clipRule="evenodd" d="M0.697674 7.76742C2.06884 7.76742 2.75256 8.18695 3.43814 8.59812C4.30233 9.11719 5.16837 9.62788 6.89674 9.62788C8.62605 9.62788 9.49209 9.11719 10.3572 8.59812C11.0428 8.18695 11.7274 7.76742 13.0995 7.76742C14.4716 7.76742 15.1563 8.18695 15.8419 8.59812C16.707 9.11719 17.573 9.62788 19.3023 9.62788C19.6874 9.62788 20 9.31533 20 8.93021C20 8.54509 19.6874 8.23254 19.3023 8.23254C17.9302 8.23254 17.2456 7.813 16.56 7.40184C15.6949 6.88277 14.8288 6.37207 13.0995 6.37207C11.3702 6.37207 10.5042 6.88277 9.63907 7.40184C8.95349 7.813 8.26884 8.23254 6.89674 8.23254C5.52558 8.23254 4.84186 7.813 4.15628 7.40184C3.29209 6.88277 2.42605 6.37207 0.697674 6.37207C0.312558 6.37207 0 6.68463 0 7.06974C0 7.45486 0.312558 7.76742 0.697674 7.76742Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0.697674 2.186C2.06884 2.186 2.75256 2.60553 3.43814 3.0167C4.30233 3.53577 5.16837 4.04646 6.89674 4.04646C8.62605 4.04646 9.49209 3.53577 10.3572 3.0167C11.0428 2.60553 11.7274 2.186 13.0995 2.186C14.4716 2.186 15.1563 2.60553 15.8419 3.0167C16.707 3.53577 17.573 4.04646 19.3023 4.04646C19.6874 4.04646 20 3.73391 20 3.34879C20 2.96367 19.6874 2.65111 19.3023 2.65111C17.9302 2.65111 17.2456 2.23158 16.56 1.82042C15.6949 1.30135 14.8288 0.790649 13.0995 0.790649C11.3702 0.790649 10.5042 1.30135 9.63907 1.82042C8.95349 2.23158 8.26884 2.65111 6.89674 2.65111C5.52558 2.65111 4.84186 2.23158 4.15628 1.82042C3.29209 1.30135 2.42605 0.790649 0.697674 0.790649C0.312558 0.790649 0 1.10321 0 1.48832C0 1.87344 0.312558 2.186 0.697674 2.186Z" />
      <path fillRule="evenodd" clipRule="evenodd" d="M0.697674 13.3488C2.06884 13.3488 2.75256 13.7684 3.43814 14.1795C4.30233 14.6986 5.16837 15.2093 6.89674 15.2093C8.62605 15.2093 9.49209 14.6986 10.3572 14.1795C11.0428 13.7684 11.7274 13.3488 13.0995 13.3488C14.4716 13.3488 15.1563 13.7684 15.8419 14.1795C16.707 14.6986 17.573 15.2093 19.3023 15.2093C19.6874 15.2093 20 14.8967 20 14.5116C20 14.1265 19.6874 13.814 19.3023 13.814C17.9302 13.814 17.2456 13.3944 16.56 12.9833C15.6949 12.4642 14.8288 11.9535 13.0995 11.9535C11.3702 11.9535 10.5042 12.4642 9.63907 12.9833C8.95349 13.3944 8.26884 13.814 6.89674 13.814C5.52558 13.814 4.84186 13.3944 4.15628 12.9833C3.29209 12.4642 2.42605 11.9535 0.697674 11.9535C0.312558 11.9535 0 12.266 0 12.6512C0 13.0363 0.312558 13.3488 0.697674 13.3488Z" />
    </g>
  ),
  wind: (
    // Paths exportados do Figma em coordenadas 30-52 — transform combina
    // translate(-25, -8) (move o origem proximo de 0) com scale(0.85) para
    // preencher o viewBox 24x24. Antes era scale(0.45) puro, deixando o
    // icone ~50% menor que admin/video/no_filter (scale 1.2 com coords 0-20).
    // SVG processa transforms direita->esquerda: translate primeiro, scale depois.
    <g transform="scale(0.85) translate(-25, -8)">
      {/* Barra horizontal superior */}
      <path d="M39.25 10.75H33.25V12.75H39.25V10.75Z" />
      {/* Barra horizontal media */}
      <path d="M35.25 14.75H30.25V16.75H35.25V14.75Z" />
      {/* Barra horizontal inferior */}
      <path d="M37.25 26.75H32.25V28.75H37.25V26.75Z" />
      {/* Turbina eolica complexa — design Figma (node-id=799-26765) */}
      <path d="M51.46 26.36L49.18 22.26C48.91 21.78 48.45 21.43 47.92 21.29L45.23 20.62C45.21 20.15 45.09 19.7 44.86 19.29L48.82 12.7C49.47 11.62 49.12 10.22 48.04 9.57C47.68 9.35 47.27 9.25 46.87 9.25C46.31 9.25 45.75 9.46 45.31 9.87L41.88 13.08C41.48 13.45 41.25 13.98 41.25 14.53V17.93C40.78 18.1 40.36 18.38 40.02 18.75H32.53C31.27 18.75 30.25 19.77 30.25 21.03C30.25 22.05 30.92 22.94 31.9 23.22L36.41 24.51C36.59 24.56 36.78 24.59 36.96 24.59C37.32 24.59 37.68 24.49 37.99 24.3L40.23 22.96C40.52 23.22 40.86 23.43 41.25 23.57V28.75C40.15 28.75 39.25 29.65 39.25 30.75H45.25C45.25 29.65 44.35 28.75 43.25 28.75V24.47L47.86 29.08C48.31 29.53 48.89 29.75 49.47 29.75C50.05 29.75 50.64 29.53 51.08 29.08C51.8 28.36 51.96 27.25 51.46 26.36ZM36.97 22.59L32.45 21.3C32.33 21.27 32.25 21.15 32.25 21.03C32.25 20.88 32.38 20.75 32.53 20.75H39.26C39.26 20.9 39.27 21.05 39.29 21.19L36.97 22.59ZM42.25 21.75C41.7 21.75 41.25 21.3 41.25 20.75C41.25 20.2 41.7 19.75 42.25 19.75C42.8 19.75 43.25 20.2 43.25 20.75C43.25 21.3 42.8 21.75 42.25 21.75ZM43.25 17.89V14.53L46.68 11.32C46.73 11.27 46.87 11.2 47.02 11.28C47.15 11.36 47.2 11.53 47.12 11.66L43.38 17.9L43.25 17.89ZM49.67 27.67C49.62 27.72 49.43 27.83 49.27 27.67L44.42 22.82C44.5 22.73 44.58 22.64 44.66 22.54L47.44 23.23L49.72 27.33C49.78 27.44 49.76 27.58 49.67 27.67Z" />
    </g>
  ),
  admin: (
    <g transform="scale(1.2, 1.2)">
      <path d="M10.0009 9.16666C11.3842 9.16666 12.5009 8.05 12.5009 6.66666C12.5009 5.28333 11.3842 4.16666 10.0009 4.16666C8.61758 4.16666 7.50091 5.28333 7.50091 6.66666C7.50091 8.05 8.61758 9.16666 10.0009 9.16666ZM10.0009 5.83333C10.4592 5.83333 10.8342 6.20833 10.8342 6.66666C10.8342 7.125 10.4592 7.5 10.0009 7.5C9.54258 7.5 9.16758 7.125 9.16758 6.66666C9.16758 6.20833 9.54258 5.83333 10.0009 5.83333Z" />
      <path d="M10.0009 10C8.46758 10 7.03425 10.4167 5.80924 11.1417C5.30091 11.4333 5.00091 11.9917 5.00091 12.575V14.1667H15.0009V12.575C15.0009 11.9917 14.7009 11.4417 14.1926 11.1417C12.9676 10.4167 11.5342 10 10.0009 10ZM6.78425 12.5C7.76758 11.9583 8.87591 11.6667 10.0009 11.6667C11.1259 11.6667 12.2342 11.9583 13.2092 12.5H6.78425Z" />
      <path d="M17.6926 6.79166L19.2342 6.15C18.2176 3.725 16.2759 1.775 13.8509 0.766663L13.2092 2.30833C15.2259 3.15833 16.8426 4.775 17.6926 6.79166Z" />
      <path d="M6.79258 2.30833L6.15091 0.766663C3.72591 1.78333 1.78424 3.725 0.767578 6.15L2.30924 6.79166C3.15924 4.775 4.77591 3.15833 6.79258 2.30833Z" />
      <path d="M2.30924 13.2083L0.767578 13.85C1.78424 16.275 3.72591 18.225 6.15091 19.2333L6.79258 17.6917C4.77591 16.8417 3.15924 15.225 2.30924 13.2083Z" />
      <path d="M13.2092 17.6917L13.8509 19.2333C16.2759 18.2167 18.2259 16.275 19.2342 13.85L17.6926 13.2083C16.8426 15.225 15.2259 16.8417 13.2092 17.6917Z" />
    </g>
  ),
  video: (
    <svg transform="scale(1.2, 1.2)">
      <path d="M14.9993 8.73325V4.99992C14.9993 4.08325 14.2493 3.33325 13.3327 3.33325H3.33268C2.41602 3.33325 1.66602 4.08325 1.66602 4.99992V14.9999C1.66602 15.9166 2.41602 16.6666 3.33268 16.6666H13.3327C14.2493 16.6666 14.9993 15.9166 14.9993 14.9999V11.2666L18.3327 14.5833V5.41659L14.9993 8.73325ZM13.3327 14.9999H3.33268V4.99992H13.3327V14.9999ZM9.68268 9.58325L7.49935 12.4999L6.14935 10.6916L4.16602 13.3333H12.4993L9.68268 9.58325Z" />
    </svg>
  ),
  locked: (
    <svg width="24" height="24" viewBox="0 0 14 18" xmlns="http://www.w3.org/2000/svg">
      <path d="M12.0007 6.08333H11.1673V4.41667C11.1673 2.11667 9.30065 0.25 7.00065 0.25C4.70065 0.25 2.83398 2.11667 2.83398 4.41667V6.08333H2.00065C1.08398 6.08333 0.333984 6.83333 0.333984 7.75V16.0833C0.333984 17 1.08398 17.75 2.00065 17.75H12.0007C12.9173 17.75 13.6673 17 13.6673 16.0833V7.75C13.6673 6.83333 12.9173 6.08333 12.0007 6.08333ZM4.50065 4.41667C4.50065 3.03333 5.61732 1.91667 7.00065 1.91667C8.38398 1.91667 9.50065 3.03333 9.50065 4.41667V6.08333H4.50065V4.41667ZM12.0007 16.0833H2.00065V7.75H12.0007V16.0833ZM7.00065 13.5833C7.91732 13.5833 8.66732 12.8333 8.66732 11.9167C8.66732 11 7.91732 10.25 7.00065 10.25C6.08398 10.25 5.33398 11 5.33398 11.9167C5.33398 12.8333 6.08398 13.5833 7.00065 13.5833Z" />
    </svg>
  ),
  open_in_new: (
    <>
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z" />
    </>
  ),
  paper_plane: (
    <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
  ),
  chip: (
    <path d="M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7C5.9 7 5 7.9 5 9v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z" />
  ),
  refresh: (
    <path d="M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z" />
  ),
  bell: (
    <path d="M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z" />
  ),
  more_horiz: (
    <path d="M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
  ),
  layers: (
    <>
      {/* Quadrado de trás — 12×12, canto superior-direito */}
      <path d="M11 3H19A2 2 0 0121 5V13A2 2 0 0119 15H11A2 2 0 019 13V5A2 2 0 0111 3Z" />
      {/* Quadrado da frente — 12×12, canto inferior-esquerdo, com recorte central */}
      <path fillRule="evenodd" d="M5 9H13A2 2 0 0115 11V19A2 2 0 0113 21H5A2 2 0 013 19V11A2 2 0 015 9ZM5 11V19H13V11H5Z" />
    </>
  ),
  no_filter: (
    <g transform="scale(1.33)">
      <path d="M13.7167 3.40833L10.7417 7.2L11.9333 8.39167C12.7917 7.3 16.0833 3.08333 16.0833 3.08333C16.5083 2.53333 16.1167 1.74167 15.425 1.74167H5.28333L6.95 3.40833H13.7167Z" />
      <path d="M1.93333 0.75L0.75 1.925L7.925 9.24167V14.2417C7.925 14.7 8.3 15.075 8.75833 15.075H10.425C10.8833 15.075 11.2583 14.7 11.2583 14.2417V12.4333L16.075 17.25L17.25 16.075L1.93333 0.75Z" />
    </g>
  ),
  star: (
    <path d="M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z" />
  ),
  sort_ascending: (
    <>
      <rect x="2" y="5" width="5" height="2" rx="1" />
      <rect x="2" y="11" width="8" height="2" rx="1" />
      <rect x="2" y="17" width="11" height="2" rx="1" />
      <rect x="19" y="10" width="2" height="8" rx="1" />
      <path d="M20 5l3 5h-6z" />
    </>
  ),
  sort_descending: (
    <>
      <rect x="2" y="5" width="11" height="2" rx="1" />
      <rect x="2" y="11" width="8" height="2" rx="1" />
      <rect x="2" y="17" width="5" height="2" rx="1" />
      <rect x="19" y="6" width="2" height="8" rx="1" />
      <path d="M20 19l-3-5h6z" />
    </>
  ),
};
